/**
 * cbpAnimatedHeader.js v1.0.0
 * http://www.codrops.com
 *
 * Licensed under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 * 
 * Copyright 2013, Codrops
 * http://www.codrops.com
 */ var cbpAnimatedHeader = function() {
    const $scroller = document.querySelector("html");
    var docElem = document.documentElement, header = document.querySelector(".navbar"), didScroll = false, changeHeaderOn = 100;
    function init() {
        window.addEventListener("scroll", function(event) {
            if (!didScroll) {
                didScroll = true;
                setTimeout(scrollPage, 250);
            }
        }, false);
    }
    function scrollPage() {
        var sy = scrollY();
        if (sy >= changeHeaderOn) classie.add(header, "navbar-shrink");
        else classie.remove(header, "navbar-shrink");
        didScroll = false;
    }
    function scrollY() {
        return window.scrollY || docElem.scrollTop || $scroller.scrollTop;
    }
    init();
}();

//# sourceMappingURL=index.dd215128.js.map
